import clsx from 'clsx';
import { FC, FunctionComponent, ReactNode, SVGProps } from 'react';
import styles from './chip.module.scss';

export interface ChipProps {
  text: string;
  Icon?: FunctionComponent<SVGProps<any>>;
  onClick?: () => void;
  colorSchema?: 'blue' | 'green' | 'yellow';
  className?: string;
  rightSection?: ReactNode;
  disabled?: boolean;
}

export const Chip: FC<ChipProps> = ({
  text,
  Icon,
  onClick,
  className,
  rightSection,
  disabled,
  colorSchema = 'blue',
}) => {
  return (
    <div
      className={clsx(
        styles.chip,
        {
          [styles.blue]: colorSchema === 'blue',
          [styles.yellow]: colorSchema === 'yellow',
          [styles.green]: colorSchema === 'green',
        },
        className,
      )}
      data-interactive={!!onClick}
      data-disabled={disabled}
      onClick={() => !disabled && onClick?.()}
    >
      {Icon && <Icon className={styles.icon} />}
      <span className={styles.chipText}>{text}</span>
      {rightSection}
    </div>
  );
};
